import { BMPrimitives, BMText } from "@traveloka/district-bloom";
import { PropsWithChildren, ReactNode } from "react";
import { StyleSheet } from "react-native";
import BMView from "../../../../components/View/BMView";
import { mobileContent } from "../../../../core/resource/mobilePayload";
import { useMobileContentResource } from "../../../../core/resource/MobileResourceProvider";
import { formatMessage } from "../../../../utils";
import MobileGenericHeader from "./MobileGenericHeader";

type Props = {
  employeeName: string;
  handleRedirectLogo(): void;
  ActionComponents: ReactNode[];
};

export default function MobileHomeHeader(props: PropsWithChildren<Props>) {
  const { children, employeeName, ...rest } = props;

  const { CorporatePostLogin: cr } = useMobileContentResource();

  const shownName = generateShownName(employeeName);

  return (
    <BMView>
      <MobileGenericHeader
        {...rest}
        backgroundBorderRadius={BMPrimitives.BMRadius.md}
      />
      <BMText
        style={styles.morningText}
        ink="BMStyleTextInkPrimaryInvert"
        testID="greeting-text"
      >
        {formatMessage(generateGreetingTime(cr), { name: shownName })}
      </BMText>

      {children}
    </BMView>
  );
}

const styles = StyleSheet.create({
  morningText: {
    marginVertical: BMPrimitives.BMSize.lg,
    marginHorizontal: BMPrimitives.BMSize.md,
  },
});

// Functions
function generateGreetingTime(
  cr: (typeof mobileContent)["CorporatePostLogin"]
) {
  const currentHour = new Date().getHours();
  if (currentHour < 12) {
    return cr.morningText;
  } else if (currentHour < 18) {
    return cr.afternoonText;
  } else {
    return cr.eveningText;
  }
}

function generateShownName(employeeName: string) {
  const splitNames = employeeName.split(" ");
  const firstName = splitNames[0];

  if (firstName.length <= 2 && splitNames.length > 1) {
    return [firstName, splitNames[1]].join(" ");
  }

  return firstName;
}
